// types of action
const Types = {
  SET_CONFIG_ITEM: "SET_CONFIG_ITEM",
  SAVE_CONFIG: "SAVE_CONFIG",
  DELETE_CONFIG: "DELETE_CONFIG",
  RESET_CONFIG: "RESET_CONFIG",
  VIEW_BOM: "VIEW_BOM",
  EDIT_BOM: "EDIT_BOM",
  SET_QUOTE_ITEM: "SET_QUOTE_ITEM",
  SET_QUOTE_ITEM: "SET_QUOTE_ITEM",
  CLEAR_PII: "CLEAR_PII",
  LOCALE_SETTINGS: "LOCALE_SETTINGS"
};
// actions
const setConfigItem = item => ({
  type: Types.SET_CONFIG_ITEM,
  payload: item
});

const setQuoteItem = item => ({
  type: Types.SET_QUOTE_ITEM,
  payload: item
});

const saveConfig = item => ({
  type: Types.SAVE_CONFIG,
  payload: item
});

const deleteConfig = item => ({
  type: Types.DELETE_CONFIG,
  payload: item
});

const configReset = item => ({
  type: Types.RESET_CONFIG
});

const viewBom = item => ({
  type: Types.VIEW_BOM
});

const editBom = item => ({
  type: Types.EDIT_BOM,
  payload: item
});

const clearPii = item => ({
  type: Types.CLEAR_PII
});

const localeSettings = item => ({
  type: Types.LOCALE_SETTINGS
})

// const deleteItem = id => ({
//   type: Types.DELETE_ITEM,
//   payload: id
// });

export default {
  setConfigItem,
  saveConfig,
  deleteConfig,
  configReset,
  viewBom,
  editBom,
  setQuoteItem,
  clearPii,
  localeSettings,
  Types
};
